import { gql, useMutation } from '@apollo/client'

export const CREATE_UNIT = gql`
  mutation($input: UnitInput) {
    createUnit(input: $input) {
      id
    }
  }
`

export const useCreateUnit = () => {
  const [mutate, { data, loading, error }] = useMutation(CREATE_UNIT)

  return { mutate, data, loading, error }
}
